import * as actionTypes from '../consts/actionTypes';

const initialState = {
    news: [],
    msgError: ''
};

export default function newsReducer(state = initialState, action) {
    const DEFAULT = { ...state };
    const ACTIONS = {
        [actionTypes.SUCCESS_GET_ALL_NEWS]: responseToReturn(),
        [actionTypes.FAILURE_GET_ALL_NEWS]: responseToReturn()
    };
    function responseToReturn() {
        let res = { ...state };
        if (action.response) {
            res = { ...state, news: action.response.data, msgError: action.message };
        }
        if (action.message) {
            res = { ...state, msgError: action.message };
        }
        return res;
    }

    let receiveAction = DEFAULT;

    if (ACTIONS[action.type] !== undefined) {
        receiveAction = ACTIONS[action.type];
    }

    return receiveAction;
}